import axios from 'axios';
import keycloak from '../../keycloak';

import {
  getApiEndpoint,
  generateHeaderToken,
  getHeaderTimestamp,
  getNonce,
  clearLocalStorage,
} from '../../modules/utils';

export const apiConfig = () => {
  const accessToken = keycloak.token;
  const appConfigData = {
    method: 'PUT,DELETE,POST,GET,OPTION',
    headers: {
      accept: 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
      nonce: getNonce(),
      timestamp: getHeaderTimestamp(),
      token: generateHeaderToken(),
    },
  };
  if (accessToken) appConfigData.headers.authorization = `bearer ${accessToken}`;

  return appConfigData;
};

const stripNonSerializable = ({ data, status }) => ({ data, status });

export const getApi = (url, params) => {
  const headers = apiConfig();
  const config = {
    headers: headers?.headers,
    params: params,
  };

  return axios.get(getApiEndpoint() + url, config).then(stripNonSerializable);
};

export const postApi = (url, apiData) => {
  return axios.post(`${getApiEndpoint()}${url}`, apiData, apiConfig()).then(stripNonSerializable);
};

export const putApi = (url, apiData) => {
  return axios.put(`${getApiEndpoint()}${url}`, apiData, apiConfig()).then(stripNonSerializable);
};

export const deleteApi = (url) => {
  return axios.delete(`${getApiEndpoint()}${url}`, apiConfig()).then(stripNonSerializable);
};

export const setupInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && [401].includes(error.response.status)) {
        clearLocalStorage();
      }

      return Promise.reject(error);
    }
  );
};
